import script from "./ControllerItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ControllerItem.vue?vue&type=script&setup=true&lang=js"

import "./ControllerItem.vue?vue&type=style&index=0&id=36ae9c81&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36ae9c81"]])

export default __exports__